(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["raket-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const disclosure=event.target.closest('.rk-localization-disclosure[open]');if(disclosure){disclosure.open=false;disclosure.querySelector('summary').focus();}});
document.addEventListener('click',event=>{document.querySelectorAll('.rk-localization-disclosure[open]').forEach(disclosure=>{if(!disclosure.contains(event.target))disclosure.open=false;});});
  } catch(e) { console.error(e); }
})();

})();
